// function openSearchInHeader(element){
//   $(element).hide();
//   $("#search-form-in-header").show("slow");
// }


$( document ).ready(function() {
    // $(".pr_thumbs_item").hide();
});

(function() {
  document.addEventListener('toggle', function(event) {
    var current = event.target;
    if (!current.matches || !current.matches('[data-jp-filter-menu]') || !current.open) return;

    document.querySelectorAll('[data-jp-filter-menu][open]').forEach(function(menu) {
      if (menu !== current) menu.removeAttribute('open');
    });
  }, true);

  document.addEventListener('click', function(event) {
    if (event.target.closest && event.target.closest('[data-jp-filter-menu]')) return;

    document.querySelectorAll('[data-jp-filter-menu][open]').forEach(function(menu) {
      menu.removeAttribute('open');
    });
  });

  document.addEventListener('change', function(event) {
    var input = event.target;
    if (!input.matches || !input.matches('#JpCollectionFiltersForm input')) return;

    if (input.classList.contains('jp-filter-group-master')) {
      document.querySelectorAll('#JpCollectionFiltersForm input[data-jp-group="' + input.dataset.jpGroup + '"]').forEach(function(groupInput) {
        if (!groupInput.disabled) groupInput.checked = input.checked;
      });
    }

    if (input.type === 'checkbox') {
      input.form.requestSubmit ? input.form.requestSubmit() : input.form.submit();
    }
  });

  document.addEventListener('input', function(event) {
    var input = event.target;
    if (input.matches && input.matches('[data-jp-size-search]')) {
      var query = input.value.trim().toLowerCase();
      var panel = input.closest('.jp-filter-menu__panel');
      if (!panel) return;

      panel.querySelectorAll('.jp-filter-menu__option').forEach(function(option) {
        var text = option.textContent.toLowerCase();
        option.style.display = !query || text.indexOf(query) !== -1 ? '' : 'none';
      });
      return;
    }

    if (!input.matches || !input.matches('[data-jp-range-min], [data-jp-range-max], [data-jp-price-min], [data-jp-price-max]')) return;

    var form = input.closest('form');
    if (!form) return;

    var minNumber = form.querySelector('[data-jp-price-min]');
    var maxNumber = form.querySelector('[data-jp-price-max]');
    var minRange = form.querySelector('[data-jp-range-min]');
    var maxRange = form.querySelector('[data-jp-range-max]');
    if (!minNumber || !maxNumber || !minRange || !maxRange) return;

    if (input === minRange) minNumber.value = minRange.value;
    if (input === maxRange) maxNumber.value = maxRange.value;
    if (input === minNumber) minRange.value = minNumber.value || 0;
    if (input === maxNumber) maxRange.value = maxNumber.value || maxRange.max;

    if (Number(minRange.value) > Number(maxRange.value)) {
      if (input === minRange || input === minNumber) {
        maxRange.value = minRange.value;
        maxNumber.value = minRange.value;
      } else {
        minRange.value = maxRange.value;
        minNumber.value = maxRange.value;
      }
    }
  });
})();
